// Shared Imports
import logo from '@/core/assets/img/logo.png'

const Logo = () => {
  return (
    <div className="flex justify-center">
      <div
        className="flex h-24 w-full max-w-xs items-center justify-center rounded-2xl bg-[linear-gradient(135deg,#3a306f_0%,#2a2a5e_55%,#1f1f4d_100%)] px-8 shadow-[0_12px_32px_-12px_rgba(20,16,60,0.55)]"
        data-testid="auth-logo-frame"
      >
        <img src={logo} alt="Bilgilig" className="h-12 w-auto" />
      </div>
    </div>
  )
}

export default Logo
